import {LegacyFormModal} from '~/components'
import {useParams} from '@eitje/bridge'
import {BillingInfo} from '@eitje/api'
import {goBack} from '~/routing/actions'
import {DISCOUNT_ITEMS} from './constants'
import {FormFields} from './form_fields'
import {NegativeDiscountWarning} from './negative_discount_warning'

export const PriceAgreement = () => {
	const {id} = useParams()
	const billingInfo = BillingInfo.useFind(id)

	const handleSubmit = params => {
		const resetParams = {discount_amt_per_user: 0, discount_pct: 0, fixed_amt_per_env: null, fixed_amt_per_user: null} // only one discount can be active at a time. Clear the other discounts
		return billingInfo.update({...resetParams, ...params})
	}

	const initialDiscount = DISCOUNT_ITEMS.find(({id}) => Boolean(billingInfo?.[id]))?.id ?? 'no_discount'

	return (
		<LegacyFormModal
			name="price_agreement"
			onSubmit={handleSubmit}
			afterSubmit={goBack}
			modalProps={{
				okButtonProps: {
					t: 'common.save',
					confirmTitle: {t: 'common.watch_out'},
					confirmText: {t: 'billing.price_agreement.negative_discount_warning'},
					confirmButtonProps: {t: 'common.save'},
				},
			}}
			width={400}
			initialValues={{discount: initialDiscount, ...billingInfo}}
		>
			<NegativeDiscountWarning />
			<FormFields />
		</LegacyFormModal>
	)
}
